import React from 'react';

interface ColProps {
  xs?: number;
  md?: number;
  className?: string;
  children?: React.ReactNode;
  'aria-label'?: string;
}

const widthMap: Record<number, string> = {
  1: 'w-1/12', 2: 'w-2/12', 3: 'w-3/12', 4: 'w-4/12',
  5: 'w-5/12', 6: 'w-6/12', 7: 'w-7/12', 8: 'w-8/12',
  9: 'w-9/12', 10: 'w-10/12', 11: 'w-11/12', 12: 'w-full',
};

const mdWidthMap: Record<number, string> = {
  1: 'md:w-1/12', 2: 'md:w-2/12', 3: 'md:w-3/12', 4: 'md:w-4/12',
  5: 'md:w-5/12', 6: 'md:w-6/12', 7: 'md:w-7/12', 8: 'md:w-8/12',
  9: 'md:w-9/12', 10: 'md:w-10/12', 11: 'md:w-11/12', 12: 'md:w-full',
};

function Col({ xs, md, className = '', children, ...rest }: ColProps) {
  const classes: string[] = ['px-3'];
  if (xs) classes.push(widthMap[xs] || '');
  if (md) classes.push(mdWidthMap[md] || '');
  if (!xs && !md) classes.push('flex-1 min-w-0');
  return (
    <div className={`${classes.join(' ')} ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}

export default Col;
